<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>邮箱设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">邮箱设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd()">
          <span>添加邮箱</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.length">
          <Table :border="false" :columns="columns1" :data="list" row-key="id" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="PdGroupName">{{ row.pdGroupName }}</template>
            <template slot-scope="{ row, index }" slot="PdKindName">{{ row.pdKindName.replace(';', '、') }}</template>
            <template slot-scope="{ row, index }" slot="Name">{{ row.name }}</template>
            <template slot-scope="{ row, index }" slot="Mob">{{ row.mob }}</template>
            <template slot-scope="{ row, index }" slot="Tel">{{ row.tel }}</template>
            <template slot-scope="{ row, index }" slot="Email">{{ row.email }}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </template>
          </Table>
        </template>
        <div class="u-empty" v-else>暂无数据</div>
        <div class="my-page" v-if="totalPages > 1">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
            @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>

      <emailAdd :show="show" @finish="init()" @close="show = false;" :options="options" :modelTitle="modelTitle" />
    </div>

  </div>
</template>

<script>
import emailAdd from "../components/email-add.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  // 邮箱设置
  name: "host-common-email",
  data () {
    return {
      list: null,
      edit: false,
      editInfo: false,
      show: false,
      options: {},
      modelTitle: '',
      columns1: [
        {
          title: "展区",
          slot: "PdGroupName",
          key: "PdGroupName",
        },
        {
          title: "展品类别",
          slot: "PdKindName",
          key: "PdKindName",
          align: "center"
        },
        {
          title: "联络人",
          slot: "Name",
          key: "Name",
          align: "center"
        },
        {
          title: "联络方式",
          slot: "Mob",
          key: "Mob",
          align: "center"
        },
        {
          title: "座机",
          slot: "Tel",
          key: "Tel",
          align: "center"
        },
        {
          title: "邮箱",
          slot: "Email",
          key: "Email",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      showChild: false,

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: 'hostSetModule/getHostExhibition',
    }),
    option () {
      return {
        exhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }
    }
  },
  created () {
    this.init();
    this.getGetAllProduct();
  },
  components: {
    emailAdd,
  },
  methods: {
    ...mapActions({
      GetAllProduct: 'registerdModule/GetAllProduct',
      getEmailByExId: 'hostEmailModule/getEmailByExId',
      delEmailById: 'hostEmailModule/delEmailById',
    }),
    async getGetAllProduct () {
      if (!(this.exhibitionInfo && this.exhibitionInfo.groupId)) return;
      let res = await this.GetAllProduct(this.exhibitionInfo.groupId);
      console.log('getGetAllProduct', res);
      if (res) {
        this.area1 = res;
        if (this.area1[0]) {
          this.areaName = this.area1[0].name || '';
        }
      }
    },
    async init () {
      let listData = await this.getEmailByExId(this.option);
      if (listData && listData.items) {
        this.list = listData.items;
        console.log('list', this.list);
        this.totalCount = listData.totalCount;
        this.totalPages = listData.totalPages;
      }
    },
    async delItem (item) {
      let result = await this.delEmailById(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd () { // 新增
      this.show = true;
      this.modelTitle = '新增邮箱';
      this.options = {
        model: null,
        msg: null,
      }
    },
    editShow (item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑邮箱';
      this.options = {
        model: 'edit',
        msg: item,
      }
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;

    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }

    &-box {
      flex: 1;
      text-align: right;
    }
  }

  .custom-wrap {
    margin: 0 auto;
    min-height: 500px;
  }
}
.my-page {
  padding: 20px;
  text-align: center;
}
</style>